
export function backendFetch(widgetId:number,addressPath:string, type:string  = 'GET', contentType?:string, content?: string) {

    //@ts-ignore
    var url = '//booking.' + import.meta.env.VITE_NFHOTEL_HOST + '/api2/'+widgetId+'/' + addressPath;
    const fetchParameters: RequestInit = {
        method:type
    };
    if(contentType && content) {
        fetchParameters.body = content;
        fetchParameters.headers = {
            'Content-Type': contentType
        }
    }
    return fetch(url, fetchParameters);
}